import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const CHANNEL_RECAP_SERVICE: string = "OrderRecapServiceChannel";
export interface IOrderRecapService {
  getOrderRecap(orderIds: any): Promise<Array<string>>;
}
